import React from 'react'
import Badge from '@material-ui/core/Badge'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    overflow: 'visible',
  },
  badge: {
    '&&': {
      top: 0,
      right: 'auto',
      left: '100%',
      transform: 'translate(8%, -50%)',
      transformOrigin: '0% 100%',
      marginLeft: theme.spacing(0.25),
    },
  },
  leadsTone: {
    '&&': {
      backgroundColor: theme.palette.blue.main,
      color: theme.palette.common.white,
    },
  },
}))

/**
 * Inline count pill for nav items and page-header tabs.
 * Use this anywhere a label needs a corner count (e.g. Leads, New, Messaging).
 */
export default function InlineCountBadge({
  count,
  children,
  tone = 'leads',
  className,
}) {
  const classes = useStyles()
  const normalizedCount = Number(count) || 0
  const showBadge = normalizedCount > 0

  if (!showBadge) {
    return <span className={className}>{children}</span>
  }

  return (
    <Badge
      color="error"
      badgeContent={normalizedCount}
      className={className}
      classes={{
        root: classes.root,
        badge: clsx(classes.badge, tone === 'leads' && classes.leadsTone),
      }}
    >
      <span>{children}</span>
    </Badge>
  )
}
